import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AppShell from "components/misc/AppShell";
import { AuthProvider } from "components/auth/context/useAuth";

function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}

export default App;
